import { useCifraClient } from "./cifra-client";

const { cifraClient } = useCifraClient();

export default {
  get(options) {
    return cifraClient.get('/api_publica/v1/estructuras', options);
  },
  getParaAnnoLectivo(idAnnoLectivo){
    return cifraClient.get('/api_publica/v1/estructuras', {
      params: { anno_lectivo_id: idAnnoLectivo }
    });
  },
  /**
   *
   * @param {*} params En params debe llegar un hash con el filtro que queremos, por ejemplo
   * { curso_id: 222 } o { ensennanza_id: 333 } etc.
   * @returns
   */
  getDetalle(params) {
    return cifraClient.get('/api_publica/v1/estructuras/detalle', {
      params,
    });
  },
  /**
   * Obtiene el detalle de múltiples estructuras escolares en una sola llamada
   * @param {Array} estructuras Array de objetos con los IDs de cada estructura
   * Por ejemplo: [{ curso_id: 333 }, { ensennanza_id: 444 }]
   * @returns {Promise} Promise que resuelve con un array de detalles de estructuras
   */
  getDetalleMultiple(estructuras) {
    return cifraClient.post('/api_publica/v1/estructuras/detalle_multiple', {
      estructuras,
    });
  }
}